import _ from 'lodash';
import type { BBModel } from 'types/story';

type ReturnValue<T> = { component: T | BBModel; index: number; path: string; parent: T | BBModel[] } | undefined;
/**
 * @param {Array<Object>}   components
 * @param {Object}          searchParams
 * @param {String}          searchParams.path   - https://lodash.com/docs/4.17.15#get
 * @param {*}               [searchParams.value]
 * @param {boolean}         [searchParams.has]  - Checks if path is a direct property of object.
 * @param {Object}          [replaceWith]       - replace found component with a received one
 *                                                (Warning: modifies original)
 * @return {{component: *, index: number}|boolean|*}
 */
export function findComponentBy<T>(
	components: T | BBModel[],
	searchParams,
	replaceWith?: any
): ReturnValue<ArrayType<T>> {
	return search(components, searchParams, replaceWith);
}

function search<T>(components: T | BBModel[], searchParams, replaceWith, path = ''): ReturnValue<ArrayType<T>> {
	if (!Array.isArray(components) || !components.length) {
		return undefined;
	}

	for (let i = 0; i < components.length; i += 1) {
		const resultPath = `${path ? `${path}.` : ''}${i}`;
		let result = searchParams.has
			? _.has(components[i], searchParams.path)
			: _.get(components[i], searchParams.path);

		if (result && (result === searchParams.value || searchParams.has)) {
			if (replaceWith) {
				_.set(components, [i], replaceWith);
			}
			return {
				component: components[i],
				index: i,
				path: resultPath,
				parent: components,
			};
		}

		result = search(components[i].children, searchParams, replaceWith, `${resultPath}.children`);

		if (result) {
			return result;
		}
	}

	return undefined;
}
